import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column", 
    justifyContent: "center",
    alignItems: "center",
    height: "100vh", 
    width: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.8)", 
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 9999 
  },
  logo: {
    width: "60px", 
    marginBottom: "20px" 
  },
  progressContainer: {
    maxWidth: "200px",
    width: "100%", 
    height: "10px", 
    backgroundColor: "#ccc", 
    borderRadius: "5px", 
    overflow: "hidden" 
  },
  progressBar: {
    height: "100%", 
    width: "0%", 
    backgroundColor: "#02A351", 
    animation: "$loading 2s linear infinite" 
  },
  "@keyframes loading": {
    "0%": {
      width: "0%"
    },
    "100%": {
      width: "100%" 
    }
  }
}));

const CommonLoading = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <img src="/image/logo.svg" alt="logo" className={classes.logo} />
      <div className={classes.progressContainer}>
        <div className={classes.progressBar} />
      </div>
    </div>
  );
};

export default CommonLoading;
